import { useInView } from '@/hooks/reveal-in-view';
import NextImage from 'next/image';
import { FC, useRef } from 'react';

import type {
  ContentfulCallToActionType,
  ContentfulCardWithImageType,
} from '@/types';

import { ContentManager } from '../content-manager';
import { Image } from '../image';
import { Link } from '../link';

interface Props {
  cta: ContentfulCallToActionType;
  section: ContentfulCardWithImageType;
}

export const PoweredBy: FC<Props> = ({ cta, section }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <section className="powered-by" ref={ref}>
      <div className="powered-by--wrapper">
        <NextImage
          src="/images/mesh-3.png"
          alt=""
          width={665}
          height={486}
          className="powered-by--bg"
        />
        <div className="powered-by--content">
          <div>
            <div
              className="powered-by--title"
              style={{
                transform: isInView ? 'none' : `translateY(20px)`,
                opacity: isInView ? 1 : 0,
                transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
              }}
            >
              {section.title && <ContentManager content={section.title} />}
              <Image
                src={section.image as any}
                alt={section.image?.title}
                className="powered-by--logos"
              />
            </div>

            {section.description && (
              <ContentManager
                content={section.description}
                className="powered-by--description"
                style={{
                  transform: isInView ? 'none' : `translateY(20px)`,
                  opacity: isInView ? 1 : 0,
                  transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
                }}
              />
            )}
          </div>

          <Link
            href={cta.buttonLink || ''}
            theme="white"
            fill="full"
            title={cta.buttonLabel}
            className="powered-by--read-more"
            style={{
              transform: isInView ? 'none' : `translateY(20px)`,
              opacity: isInView ? 1 : 0,
              transition: 'all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1)',
            }}
          >
            {cta.buttonLabel}
          </Link>
        </div>
      </div>
    </section>
  );
};
